<template lang="html">
  <div>
    <div class="orderHeader">
      <div class="orderStatus">
        <div class="statusItem statusDescirption">
          <div class="statusDescirptionL">
            <img class="iconTime" :src="this.orderDescribeImg()" />
            <span ref="status">{{ synthesisStateDesc }}</span>
          </div>
          <a
            class="statusDescirptionR"
            v-if="order.refundState == 20 || order.refundState == 30"
            @click="toRefund(order.orderId)"
          >
            退款详情<i class="iconfont icon-youjiantou"></i>
          </a>
          <div v-if="hasApplyRefund" class="has-applyed">已申请退款</div>
          <div v-if="hasApplyService" class="has-applyed">已申请售后</div>
        </div>
        <div
          v-if="
            isAsignYsOrder && autoConfirmTime && isService && !hasApplyService
          "
          class="time-offset"
        >
          还剩 {{ autoConfirmTime }} 后自动确认
        </div>
        <div class="statusItem">
          <div v-if="order.refundState == 20" class="statusTime">
            <span class="statusTimeMD">{{
              $$dateFormat(order.refundTime, 'YY.MM.DD hh:mm:ss')
            }}</span
            >申请退款
          </div>
          <div v-else-if="order.refundState == 30" class="statusTime">
            <span class="statusTimeMD">{{
              $$dateFormat(order.refundTime, 'YY.MM.DD hh:mm:ss')
            }}</span
            >退款完成
          </div>
          <!--refundState == 40 退款失败不显示退款信息-->
          <!-- <div v-else-if="order.refundState == 40" class="statusTime">
            <span class="statusTimeMD">{{
              $$dateFormat(order.refundTime, 'YY.MM.DD hh:mm:ss')
            }}</span
            >申请退款
          </div> -->
          <div
            v-else-if="
              order.refundState == 10 &&
              order.orderState == 70 &&
              order.useEndtime
            "
            class="statusTime"
          >
            过期时间<span class="statusTimeMD">{{
              $$dateFormat(order.useEndtime, 'YY.MM.DD hh:mm:ss')
            }}</span>
          </div>
          <div
            v-else-if="
              order.refundState == 10 &&
              ((+order.isPayPeriod == 1 &&
                order.payPeriodInfo &&
                order.payPeriodInfo.prePayOrder &&
                order.payPeriodInfo.prePayOrder.preOrderState == 10) ||
                (+order.isPayPeriod == 0 && order.orderState == 10))
            "
            class="statusTime"
          >
            还剩<span class="statusTimeMD">{{ time }}</span
            >后自动取消
          </div>
          <div
            v-else-if="order.refundState == 10 && order.orderState == 50"
            class="statusTime"
          >
            取消时间<span class="statusTimeMD">{{
              $$dateFormat(order.cancelTime, 'YY.MM.DD hh:mm:ss')
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { B_ORDER_YS } from '@/business'
import { isEmptyObject } from '@/utils'
import { offsetTime, is7More } from './utils'
import { isNewAsignedMonthInLaw } from '@/business/order'

export default {
  props: {
    order: {
      type: Object,
      default() {
        return {}
      }
    },
    groupTime: {
      // 拼团结束时间
      type: Number,
      default: 0
    },
    synthesisStateDesc: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      timer: null,
      groupTimer: null,
      offsetTimer: null,
      time: '',
      leftTime: 0,
      groupLeftTime: '',
      autoConfirmTime: '' //自动确认收货时间
    }
  },
  mounted() {
    this.count()
  },
  watch: {
    groupTime(val) {
      if (this.order.channelType === 4 && this.order.orderState === 10 && val) {
        this.calculateRemainingTime()
        this.groupTimer = setInterval(() => {
          this.calculateRemainingTime()
        }, 1000)
      }
    }
  },
  computed: {
    isAsignYsOrder() {
      return isNewAsignedMonthInLaw(this.order)
    },
    // 是否已申请退款
    hasApplyRefund() {
      const { signRefundInfo = {}, refundState: refundSta } = this.order
      const { refundState = '' } = signRefundInfo
      // 申请过售后，且退款没有 10.未申请退款
      return (
        !isEmptyObject(signRefundInfo) &&
        refundState == 0 &&
        [10].includes(refundSta)
      )
    },
    //是否已经申请售后
    hasApplyService() {
      const { signSasInfo = {}, refundState = '' } = this.order
      const { sasState = '' } = signSasInfo
      // 申请过售后，且退款没有 10.未申请退款
      return (
        !isEmptyObject(signSasInfo) &&
        sasState == 0 &&
        [10].includes(refundState)
      )
    },
    isService() {
      return this.$refs.status.innerText == '服务中'
    }
  },
  destroyed() {
    this.groupTimer && clearInterval(this.groupTimer)
    this.offsetTimer && clearInterval(this.offsetTimer)
  },
  methods: {
    toRefund(id) {
      location.href = `//life.cekid.com/v/order/${id}/refund`
    },
    copyOrderId() {},
    timeExpire(timeLeft) {
      let timeStr = ''
      if (timeLeft > 0) {
        // 计算相差分钟数
        const minutes = Math.floor(timeLeft / 60)
        // 计算相差秒数
        const seconds = Math.round(timeLeft % 60)
        if (minutes > 0) {
          timeStr += `${minutes}分钟`
        }
        if (seconds > 0) {
          timeStr += `${seconds}秒`
        }
        if (minutes === 0 && seconds === 0) {
          location.reload()
        }
      } else {
        clearTimeout(this.timer)
      }
      return timeStr === '' ? '00分00秒' : timeStr
    },
    calculateRemainingTime() {
      const endTime = this.groupTime || 0
      const nowTime = Date.now()
      const left = (endTime - nowTime) / 1000
      let day = 0,
        hour = 0,
        minute = 0,
        second = 0
      if (left > 0) {
        day = Math.floor(left / (60 * 60 * 24))
        hour = Math.floor(left / (60 * 60)) - day * 24
        minute = Math.floor(left / 60) - day * 24 * 60 - hour * 60
        second =
          Math.floor(left) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
        if (day <= 9) {
          day = `0${day}`
        }
        if (hour <= 9) {
          hour = `0${hour}`
        }
        if (minute <= 9) {
          minute = `0${minute}`
        }
        if (second <= 9) {
          second = `0${second}`
        }
        this.groupLeftTime = `${day}天${hour}小时${minute}分${second}秒`
      }
    },
    count() {
      this.leftTime = this.order.timeLeftToPay * 1 // 剩余时间单位秒
      this.time = this.timeExpire(this.leftTime)
      this.timer = setInterval(() => {
        this.leftTime = this.leftTime - 1
        this.time = this.timeExpire(this.leftTime)
      }, 1000)
      const { overTimeWriteTime } = Array.isArray(this.order.barcodeList)
        ? this.order.barcodeList[0]
        : { overTimeWriteTime: '' }
      // 小于七天的时候才会倒计时
      if (!is7More(overTimeWriteTime)) {
        this.autoConfirmTime = offsetTime(overTimeWriteTime)
        this.offsetTimer = setInterval(() => {
          this.autoConfirmTime = offsetTime(overTimeWriteTime)
        }, 1000 * 60)
      }
    },
    orderDescribeImg() {
      const { orderState, refundState } = this.order
      // 1: 待支付, 2:已取消, 3: 待服务, 4: 待评价, 5: 已完成, 6: 已过期, 7: 申请退款中, 8:退款成功,  9 退款失败
      const orderD = [
        require('../../assets/images/order/icon-orderDescribeImg0.png'),
        require('../../assets/images/order/icon-orderDescribeImg1.png'),
        require('../../assets/images/order/icon-orderDescribeImg2.png'),
        require('../../assets/images/order/icon-orderDescribeImg3.png'),
        require('../../assets/images/order/icon-orderDescribeImg4.png'),
        require('../../assets/images/order/icon-orderDescribeImg5.png'),
        require('../../assets/images/order/icon-orderDescribeImg6.png'),
        require('../../assets/images/order/icon-orderDescribeImg7.png'),
        require('../../assets/images/order/icon-orderDescribeImg8.png')
      ]
      // refundState 10.未申请退款20.已申请退款30.退款完成40退款失败(可选项)
      // orderState 10.待支付20.待使用30.待评价40.已完成50.已取消  70.已过期(可选项)
      if (refundState == 20) {
        // 退款申请
        return orderD[6]
      } else if (refundState == 30) {
        // 退款完成
        return orderD[7]
      } else if (refundState == 40) {
        // 退款失败，退款失败不显示退款状态，根据workstate显示笑脸
        return orderD[2]
      } else if (refundState == 10) {
        if (orderState == 10) {
          return orderD[0]
        } else if (orderState == 20) {
          return orderD[2]
        } else if (orderState == 30) {
          return orderD[3]
        } else if (orderState == 40) {
          return orderD[4]
        } else if (orderState == 50) {
          return orderD[1]
        } else if (orderState == 70) {
          return orderD[5]
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.order-status {
  margin-bottom: rem(21px);

  time {
    display: block;
    margin-top: rem(20px);
    color: #666;
  }
  .item-cell {
    @include border(bottom);

    &:last-child {
      &::before {
        border: 0;
      }
    }
  }
  .copythis {
    padding: rem(10px) rem(15px);
    font-size: rem(24px);
    @include border(all, #4f4f4f);
  }
  .wait-pay {
    .item-cell {
      &::before {
        border: 0;
      }
    }
  }
  .unpay {
    background: #fee6f1;
    p:first-of-type {
      margin-bottom: rem(20px);
    }
  }
  .mt15 {
    margin-top: rem(15px);
  }
}

.orderStatus {
  padding: rem(40px) rem(24px) rem(20px);
  // background-image: linear-gradient(122deg, #FF2424 0%, #FF387A 100%);
  // border-radius: 0 0 16px 16px;
  // height: rem(224px);

  .statusItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .has-applyed {
      display: inline-block;
      color: #fff;
    }
  }

  .time-offset {
    margin-top: rem(20px);
    margin-left: rem(60px);
    display: block;
    font-size: rem(26px);
    color: #ffffff;
    line-height: rem(32px);
  }
  .statusDescirption {
    &L {
      display: flex;
      align-items: center;
      font-size: rem(40px);
      color: #fff;
      line-height: 1;
      font-weight: 700;
      .iconTime {
        width: rem(48px);
        height: rem(48px);
        margin: 0 rem(12px) 0 0;
      }
    }
    &R {
      font-size: rem(26px);
      color: #ffffff;
      text-align: right;
      line-height: rem(32px);
    }
  }

  .statusTime {
    margin: rem(20px) 0 0 rem(60px);
    font-size: rem(26px);
    color: #ffffff;
    line-height: rem(32px);

    &MD {
      font-weight: 500;
      margin: 0 rem(5px);
    }
  }
}
</style>
